import React from "react";
import { Outlet } from "react-router-dom";

const Departments = () => {
  return <Outlet />;
};

export default React.memo(Departments);
